// extracted by mini-css-extract-plugin
export default {"Main":"Table_Main__W1mSW","table":"Table_table__55sK9"};